import styled from "styled-components"

export const HomeContainer = styled.div`  
    padding-top: 8px;
`;